import React, { useEffect, useState } from "react"
import {
    Grid,
    Button,
    Typography,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    makeStyles,
} from "@material-ui/core"
import MapIcon from "@material-ui/icons/Map"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import CancelButton from "./CancelButton"

const useStyles = makeStyles({
    telaDetalhesEntrega: {
        alignItems: "center",
        textAlign: "center",
        maxWidth: "450px",
    },
    detalhesEntrega: {
        padding: "12px",
    },
    detalheEntregaUuid: {
        paddingBottom: "10px",
    },
})

export default function DetalhesEntregaUber({
    detalhesEntregaUber,
    abrirDetalhes,
    setAbrirDetalhes,
    setAbrirCancelamento,
    buscarDetalhes,
}) {
    const classes = useStyles()

    const [mostrarBotoes, setMostrarBotoes] = useState(false)

    const handleClose = () => {
        setAbrirDetalhes(false)
    }

    const foiEntregueOuCancelado = statusDoPedido => {
        setMostrarBotoes(true)
        if (!detalhesEntregaUber) setMostrarBotoes(false)
        const statusInvalidos = ["delivered", "canceled", "returned"]
        statusInvalidos.forEach(statusInvalido => {
            if (statusDoPedido === statusInvalido) {
                setMostrarBotoes(false)
            }
        })
    }

    useEffect(() => {
        if (abrirDetalhes) {
            buscarDetalhes()
        }
    }, [abrirDetalhes])

    useEffect(() => {
        foiEntregueOuCancelado(detalhesEntregaUber.status)
    }, [detalhesEntregaUber])

    return (
        <Dialog open={abrirDetalhes} onClose={handleClose}>
            <DialogTitle>
                <IconButton className="setaVoltarModal" onClick={handleClose}>
                    <ArrowForwardIosIcon />
                </IconButton>
                Detalhes
            </DialogTitle>
            <DialogContent className={classes.telaDetalhesEntrega}>
                <Grid container>
                    <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className={classes.detalheEntregaUuid}
                    >
                        <Typography variant="button">UUID</Typography>
                        <Typography variant="h5">
                            {detalhesEntregaUber.status &&
                                abrirDetalhes &&
                                detalhesEntregaUber.uuid.slice(-5)}
                        </Typography>
                    </Grid>
                    <Grid container direction="row" item lg={12} md={12} sm={12} xs={12}>
                        <Grid container item lg={6} md={6} sm={6} xs={12}>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className={classes.detalhesEntrega}
                            >
                                <img
                                    width={120}
                                    height={115}
                                    src={detalhesEntregaUber.fotoEntregador}
                                />
                            </Grid>
                            {mostrarBotoes && (
                                <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className={classes.detalhesEntrega}
                                >
                                    <Button
                                        variant="contained"
                                        href={detalhesEntregaUber.urlAcompanhamento}
                                        target={"_blank"}
                                        endIcon={<MapIcon />}
                                        maxWidth
                                    >
                                        Acompanhar
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                        <Grid container item direction="row" lg={6} md={6} sm={6} xs={12}>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className={classes.detalhesEntrega}
                            >
                                <Typography variant="button">Nome</Typography>
                                <Typography variant="body2">
                                    {detalhesEntregaUber !== {} &&
                                        detalhesEntregaUber.nomeEntregador}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className={classes.detalhesEntrega}
                            >
                                <Typography variant="button">Telefone</Typography>
                                <Typography variant="body2">
                                    {detalhesEntregaUber !== {} &&
                                        detalhesEntregaUber.telefoneEntregador}
                                </Typography>
                            </Grid>
                            <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                className={classes.detalhesEntrega}
                            >
                                <Typography variant="button">Veículo</Typography>
                                <Typography variant="body2">
                                    {detalhesEntregaUber !== {} &&
                                        detalhesEntregaUber.veiculoEntregador}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {detalhesEntregaUber.observacao && detalhesEntregaUber.status === "canceled" && (
                    <Grid
                        maxWidth
                        item
                        className={classes.detalhesEntrega}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                    >
                        <Typography variant="button">Observação</Typography>
                        <Typography variant="body1">{detalhesEntregaUber.observacao}</Typography>
                    </Grid>
                )}
                {mostrarBotoes && (
                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                        <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className={classes.detalhesEntrega}
                        >
                            <CancelButton
                                text="Cancelar entrega"
                                handleClick={() => {
                                    setAbrirCancelamento(true)
                                }}
                            />
                        </Grid>
                    </Grid>
                )}
            </DialogContent>
        </Dialog>
    )
}
